exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".active[_v-d3afd664]{background-color:#000;color:#fff}.disabled span[_v-d3afd664]{border-color:#bbb!important;color:#bbb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-d3afd664&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Pagination.vue
// module id = 461
// module chunks = 0